const FormResources = {

    form_data:{
        number:             '',
        description:        '',
        class:              1,
        prep_minutes:       '',
        start_time:         '00:00',
        end_time:           '01:00',
        clenaup_minutes:    '',
        work_time:          '',
        total_time:         '',
    },
    
    form_format:[
        {
            css_class:  'col-md-6',
            type:       'number',
            maxlength:  '',
            disabled:   false,
            step:       'any',
            name:       'Number #:',
            model_name: 'number',
            ref:        'number_input',
            ref_alt:    'number_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:   45,
            disabled:   false,
            step:       '',
            name:       'Description:',
            model_name: 'description',
            ref:        'description_input',
            ref_alt:    'description_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Class:',
            model_name: 'class',
            ref:        'class_input',
            ref_alt:    'class_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'number',
            maxlength:  '',
            disabled:   false,
            step:       'any',
            name:       'Prep minutes:',
            model_name: 'prep_minutes',
            ref:        'prep_minutes_input',
            ref_alt:    'prep_minutes_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'number',
            maxlength:  '',
            disabled:   false,
            step:       'any',
            name:       'Cleanup Minutes:',
            model_name: 'clenaup_minutes',
            ref:        'clenaup_minutes_input',
            ref_alt:    'clenaup_minutes_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'time',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Start Time:',
            model_name: 'start_time',
            ref:        'start_time_input',
            ref_alt:    'start_time_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'time',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'End Time:',
            model_name: 'end_time',
            ref:        'end_time_input',
            ref_alt:    'end_time_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:   45,
            disabled:   true,
            step:       '',
            name:       'Work Time:',
            model_name: 'work_time',
            ref:        'work_time_input',
            ref_alt:    'work_time_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:   45,
            disabled:   true,
            step:       '',
            name:       'Total Hours:',
            model_name: 'total_time',
            ref:        'total_time_input',
            ref_alt:    'total_time_input_alt',
            required:   false,
        },
        
        
    ],

    shift_options:  [
        {
            id:     1,
            name:   'Day',
        },
        {
            id:     2,
            name:   'Evening',
        },
        {
            id:     3,
            name:   'Night',
        },
    ],

}

export default FormResources;